import axios from 'axios';
import Cookies from './cookies';
import localStorage from './localStorage';
import { USER_ROLES } from '~/config';
import { isDevMode } from '~/utils/mainHelpers/isDevMode';

const appendExtraData = (payload) => {
  if (!payload) return;
  // Overseas API
  if (payload && (payload.role || payload.lang)) return payload;
  console.log(localStorage.language);
  return {
    ...payload,
    role:
      (payload && payload.role) ||
      (localStorage &&
        localStorage.userProfile &&
        localStorage.userProfile.role) ||
      USER_ROLES.USER,
    lang: (payload && payload.lang) || (localStorage && localStorage.language),
  };
};

export const addInterceptors = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.isForUploadS3) {
        // console.log('--- upload at S3 ---');
        return config;
      }

      // !! Test SSO authen in dev mode first
      if (isDevMode()) {
        if (!config.headers || !config.headers.Authorization) {
          const token = Cookies.get('sessionId');
          if (token) {
            config.headers.common.Authorization = `${token}`;
            config.headers.Authorization = `${token}`;
          }
        }
      }

      config.params = appendExtraData(config.params);
      config.data = appendExtraData(config.data);

      // if (process.browser) {
      //   console.log('AXIOS REQUEST', config.method, config.url);
      //   console.log('REQUEST PARAMS', config.params);
      //   console.log('REQUEST DATA', config.data);
      // }

      return config;
    },
    (error) => Promise.reject(error.response),
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      // if (process.browser && response && response.config) {
      //   console.log(
      //     'AXIOS RESPONSE',
      //     response.config.method,
      //     response.config.url
      //   );
      //   console.log(response.status, response.data);
      // }
      // Do something with response data
      if (response && response.data) {
        return response.data;
      }

      return response;
    },
    (error) => {
      if (error.config) {
        console.error('AXIOS ERROR', error.config, error.config.url);
        // error.response &&
        //   console.error(
        //     'AXIOS ERROR',
        //     error.response.status,
        //     error.response.data
        //   );
      } else {
        console.log('AXIOS CUSTOM ERROR', error);
      }
      return Promise.reject(error);
    },
  );
};

export default axios;
